import Axios from "axios"

import {BASE} from './config';

// import { URLSearchParams } from "url";


const UPLOAD_API = '/aapi/upload'
// const UPLOAD_API = 'https://admin.zkfine.com/aapi/upload'

// 实际业务中需要自己实现对应上传逻辑
export const upload = async (file) => {
  try {
    const body = new FormData()
    body.append('source', file)
    const resp = await fetch(UPLOAD_API, {
      method: 'POST',
      body,
    })
    console.log(resp);
    const json = await resp.json()
    console.log(json);
    // return包含 url 的一个对象 例如: {url:'https://img.yzcdn.cn/vant/sand.jpg'}
    return json.image
  } catch (error) {
    return { url: `/${file.name}` }
  }
}

export const loadProjects = ()=>{
  return Axios.get(BASE+'/aapi/projects').then(ret=>{
    return ret.data;
  })
}

export const loadProject = (id)=>{
  return Axios.get(BASE+'/api/projects/'+id).then(ret=>{
    return ret.data;
  })
}


export const deleteProject = (id)=>{
  return Axios.delete(BASE+'/aapi/project/'+id).then(ret=>{
    console.log(ret.data);
    return ret.data;
  });
}

export const duplicateProject = (id)=>{
    return Axios.post(BASE+'/aapi/duplicateproject/'+id).then(ret=>{
        return ret.data;
    })
}

export const deleteAd = (id)=>{
  return Axios.delete(BASE+'/aapi/ad/'+id).then(ret=>{
    console.log(ret.data);
    return ret.data;
  })
}

export const addOrUpdateAd = (options)=>{
  return Axios.post(BASE+'/aapi/ad',options).then(ret=>{
    return ret.data;
  })
}

export const loadAds = ()=>{
  return Axios.get(BASE+'/api/ad').then(ret=>{
    return ret.data;
  })
}

export const loadAd = (id)=>{
  return Axios.get(BASE+'/api/ad/'+id).then(ret=>{
    return ret.data;
  })
}

export const activateAd=(id)=>{
  return Axios.post(BASE+'/aapi/ad/activate',{id}).then(ret=>{
    return ret.data;
  })
}
export const deactivateAd=(id)=>{
  return Axios.post(BASE+'/aapi/ad/deactivate',{id}).then(ret=>{
    return ret.data;
  })
}

export const loadUsers=(offset=0,criteria)=>{
  //api error: start is actually the offset
  return Axios.get(BASE+'/aapi/users?start='+offset+(!!criteria?'&criteria='+criteria:'')).then(ret=>{
    return ret.data;
  })
}

export const loadUserCount=()=>{
  return Axios.get(BASE+'/aapi/usercount').then(ret=>{
    return ret.data;
  })
}

export const getPools=()=>{
  return Axios.get(BASE+'/aapi/pools').then(ret=>{
    return ret.data;
  })
}

export const getPoolMemberCount = (id)=>{
  return Axios.get(BASE+'/aapi/pools/'+id+'/member_count').then(ret=>{
    return ret.data;
  })
}
export const getPoolUninitiatedCount = (id)=>{
  return Axios.get(BASE+'/aapi/pools/uninitiated').then(ret=>{
    return ret.data;
  })
}

export const queryWithdrawRequests = (type,day,status,op,amount)=>{
    const params = new URLSearchParams({
        type,day:day.format('YYYY-MM-DD'),status,op,amount
    })
    return Axios.get(BASE+'/aapi/withdrawsq?'+params.toString()).then(ret=>{
        console.log(ret);
        return ret.data;
    })
}

export const loadWithdrawRequests = (page)=>{
  return Axios.get(BASE+'/aapi/withdraws'+'?'+'page='+page).then(ret=>{
    return ret.data;
  })
}

export const getWithdrawCount = ()=>{
    return Axios.get(BASE+'/aapi/withdraws/count').then(ret=>{
        return ret.data;
    })
}

export const loadRejectedWithdrawRequests = ()=>{
  return Axios.get(BASE+'/aapi/withdraws/rejected').then(ret=>{
    return ret.data;
  })
}

export const loadApprovedWithdrawRequests = ()=>{
  return Axios.get(BASE+'/aapi/withdraws/approved').then(ret=>{
    return ret.data;
  })
}

export const executeWithdrawRequest = (id, txid)=>{
  return Axios.put(BASE+`/aapi/withdraw/${id}/ok`, { txid }).then(ret=>{
    return ret.data;
  })
}
export const executeWithdrawRequestProcess = (id, txid)=>{
    return Axios.put(BASE+`/aapi/withdraw/${id}/process`, { txid }).then(ret=>{
      return ret.data;
    })
  }

export const rejectWithdrawRequest = (withdrawRequestId)=>{
  return Axios.put(BASE+'/aapi/withdraw/reject',{id:withdrawRequestId}).then(ret=>{
    return ret.data;
  });
}


export const getPrice =()=>{
  return Axios.get(BASE+'/api/price').then(ret=>{
    return ret.data;
  }).catch(err=>{
    return {data:3.14}
  })
}

export const updatePrice = (price)=>{
  return Axios.post(BASE+'/aapi/price',{price}).then(ret=>{
    return ret.data;
  })
}

export const loadTasks = ()=>{
  return Axios.get(BASE+'/aapi/tasks').then(ret=>{
    return ret.data;
  })
}

export const loadTaskSubmit = (taskId)=>{
  return Axios.get(BASE+'/aapi/tasks/'+taskId+'/submitted').then(ret=>{
    return ret.data;
  })
}

export const web3auth = (data) => {
  return Axios.put(BASE+'/aapi/web3auth', data).then(ret=>{
    return ret.data;
  })
}

export const isSigned = (data) => {
  return Axios.get(BASE+'/aapi/login/info', data).then(ret=>{
    return ret.data;
  })
}

export const logout = () => {
  return Axios.post(BASE+'/aapi/logout').then(ret=>{
    return ret.data;
  })
}

export const loadNewRequests = (id)=>{
  return Axios.get(BASE+'/aapi/withdraws/new/'+id).then(ret=>{
    return ret.data;
  })
}

export const loadNewestRequest = (id)=>{
  return Axios.get(BASE+'/aapi/withdraw/request/newest').then(ret=>{
    return ret.data;
  })
}

export const getUserDetail = (id)=>{
    return Axios.get(BASE+'/aapi/user/'+id).then(ret=>{
        return ret.data;
    })
}

export const modifyUserAuth = (id,type,checked)=>{
    if(!id||!type){
        console.error('[WARN]internale error:','id/type should not be null');
        return;
    }
    return Axios.put(BASE+'/aapi/user/auth/'+id,{type,checked}).then(ret=>{
        return ret.data;
    }).catch(err=>{
        return {code:500}
    })
}


export const getNoticeDetails=(id)=>{
    return Axios.get(BASE+`/notice/${id}`);
}

export const getNotices=()=>{
    return Axios.get('/aapi/notices').then(res=>{
        return res.data;
    })
}

export const addNotice = (lang,title,content)=>{
    return Axios.post(BASE+'/aapi/notice/new',{lang,title,content,operator:'admin'});
}

export const updateNotice = (id,lang,title,content)=>{
    return Axios.post(BASE+'/aapi/notice/'+id,{lang,title,content,operator:'admin'});
}

export const loadNotice = (id)=>{
    return Axios.get(BASE+'/aapi/notice/'+id).then(ret=>{
        return ret.data;
    })
}

export const showNotice = (id)=>{
    return Axios.put(BASE+'/aapi/notice/'+id,{show:true}).then(ret=>{
        return ret.data;
    })
}

export const hideNotice = (id)=>{
    return Axios.put(BASE+'/aapi/notice/'+id,{show:false}).then(ret=>{
        return ret.data;
    })
}

export const deleteNotice = (id)=>{
    return Axios.delete(BASE+'/aapi/notice/'+id).then(ret=>{
        return ret.data;
    })
}

export const queryDeposits = async (paginationModel)=>{

    try{
        const rowCount = await Axios.get(BASE+'/aapi/deposits_count').then(ret=>{

            return ret.data?.data;
        })

        const rows =  await Axios.post(BASE+'/aapi/getdeposits',paginationModel).then(ret=>{

            return ret.data?.data;
        })
        return {rowCount,rows};
    }
    catch(err){
        console.error(err);
    }
}

export const queryDeposits2 = async (type,day,userId,coin,op,amount)=>{
    const params = new URLSearchParams({
        type,
        day,
        userId,
        coin,op,amount
    })
    return Axios.get(BASE+'/aapi/deposits2?'+params.toString()).then(ret=>{
        return ret.data;
    })
}

export const getUserInviter = async (id)=>{
    if(!id)return;
    return Axios.get(BASE+'/aapi/user/'+id+'/inviteby').then(ret=>{
        return ret.data;
    });
}

export const getUserNFTHistories = (id)=>{
    if(!id)return;
    return Axios.get(BASE+'/aapi/energy/owner/'+id).then(ret=>{
        return ret.data;
    })
}
export const getNFTHistories = (id)=>{
    if(!id)return;
    return Axios.get(BASE+'/aapi/nfthistory/owner/'+id).then(ret=>{
        return ret.data;
    })
}

export const getUserNFTTransfers = (userId,tokenId)=>{
    if(!userId||!tokenId)return;
    return Axios.get(BASE+`/aapi/nft/transfers/${tokenId}/${userId}`).then(ret=>{
        return ret.data;
    })
}

export const queryNFTTransfer =(tokenId)=>{
    if(!tokenId)return;
    return Axios.get(BASE+`/aapi/nft/transfers/${tokenId}`).then(ret=>{
        return ret.data;
    })
}

export const queryNFT =(tokenId)=>{
    if(!tokenId)return;
    return Axios.get(BASE+`/aapi/nft/${tokenId}`).then(ret=>{
        return ret.data;
    })
}

export const getUserByAddress = (address)=>{
    if(!address)return;
    return Axios.get(BASE+`/aapi/users/address/${address}`).then(ret=>{
        return ret.data;
    })
}

export const getFleets = ()=>{
    return Axios.get(BASE+'/aapi/pools').then(ret=>{
        return ret.data;
    })
}
export const getFleetMember = (id)=>{
    //return Axios.get(BASE+`/aapi/fleets/${id}/members`).then(ret=>{
    return Axios.get(BASE+`/aapi/fleets/:id/members`).then(ret=>{
        return ret.data
    })
}
export const getFleetRecords = (id, paginationModel)=>{
    return Axios.get(BASE+`/aapi/pool/${id}/records`, { params: paginationModel }).then(ret=>{
        return ret.data
    })
}

export const getMining = (address)=>{
    return Axios.get(BASE+'/aapi/mining/'+address).then(ret=>{
        return ret.data;
    })
}

export const getStakes = (address)=>{
    return Axios.get(BASE+'/aapi/stakesof/'+address).then(ret=>{
        return ret.data;
    })
}

export const getBelongsToFleet = (address)=>{
    return Axios.get(BASE+'/aapi/fleetof/'+address).then(ret=>{
        return ret.data;
    })
}

export const repair = (address,reason,amount,memo)=>{
    return Axios.post(BASE+'/aapi/repair',{address,amount,reason,memo}).then(ret=>{
        return ret.data;
    })
}

export const getOneAccelerator = ()=>{
    return Axios.get(BASE+'/aapi/one/accelerator').then(ret=>{
        return ret.data;
    })
}
export const getAuctions = (projectId)=>{
    return Axios.get(BASE+'/aapi/auctions/'+projectId).then(ret=>{
        return ret.data;
    })
}

export const rejectAuction =(auctionId)=>{
    return Axios.put(BASE+'/aapi/rejectauction/'+auctionId).then(ret=>{
        return ret.data;
    })
}

export const approveAuction =(auctionId)=>{
    return Axios.put(BASE+'/aapi/approveauction/'+auctionId).then(ret=>{
        return ret.data;
    })
}

export const showProject = (id,show)=>{
    return Axios.put(BASE+'/aapi/showproject/'+id,{show}).then(ret=>{
        return ret.data;
    })
}

export const getNetMining = (id)=>{
    return Axios.get(BASE+'/aapi/netmining/'+id).then(ret=>{
        return ret.data;
    })
}

export const getPoolHistory = (address)=>{
    return Axios.get(BASE+'/aapi/poolhistory/'+address).then(ret=>{
        return ret.data;
    })
}

export const getUnstakeInAccount = (id)=>{
    return Axios.get(BASE+'/aapi/unstakefromaccount/'+id).then(ret=>{
        return ret.data;
    })
}

export const getReleaseStake = (id)=>{
    return Axios.get(BASE+'/aapi/releasetostake/'+id).then(ret=>{
        return ret.data;
    })
}

export const getL3Subscriptions = (roundId)=>{
    return Axios.get(BASE+'/aapi/l3subscriptions/'+roundId).then(ret=>{
        return ret.data;
    })
}

export const closeL3Round = (roundId)=>{
    return Axios.post(BASE+'/aapi/closel3',{roundId}).then(ret=>{
        return ret.data;
    })
}

export const getL3Discounts = (roundId)=>{
    return Axios.get(BASE+'/aapi/l3discounts/'+roundId).then(ret=>{
        return ret.data;
    })
}

export const getNetstakes = (userId) =>{
    if(!userId)return;
    return Axios.get(BASE+'/aapi/netstakes/'+userId).then(ret=>{
        return ret.data;
    })
}